import { render } from "./ComponenteCalderasGas.vue?vue&type=template&id=16dce172&scoped=true"
import script from "./ComponenteCalderasGas.vue?vue&type=script&lang=js"
export * from "./ComponenteCalderasGas.vue?vue&type=script&lang=js"

import "./ComponenteCalderasGas.vue?vue&type=style&index=0&id=16dce172&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16dce172"]])

export default __exports__